const { gql } = require('graphql-request')

export const GENERATED_REPORT_FRAGMENT = gql`
  fragment generatedReportInfo on GeneratedReport {
    id
    name
    url
    bondsman
    status
    error
    metadata
    createdAt
    modifiedAt
  }
` 